<div class="p-3 text-left" *ngIf="product">
    <h3 style="color: #323232;    margin-bottom: 2px;">{{product.name}}</h3>
    <div style="margin-bottom:5px;color:#888; ">{{product.sku}}</div>
    <div class="row no-gutters">
        <div class="col-md-6 col-12">
            <div class="product-details-price ">
                <div>
                        <span *ngIf="!hasSpecialPrice" style="color:#454545; font-size: 18px "
                              class="product-price"> {{env.defaultCurrency}}
                            <label style="font-weight: 700;">{{product.price | number:'.3'}} </label>   </span>
                    <span *ngIf="hasSpecialPrice" class="product-price"
                          style="color:red; font-weight: bold; font-size: 18px "> {{env.defaultCurrency}} {{this.product.getSpecialPrice() | number:'.3'}}    </span>
                    <span *ngIf="hasSpecialPrice" class="product-price"
                          style="color: grey;text-decoration-line: line-through; font-size: 18px "> {{env.defaultCurrency}} {{product.price}} </span>
                </div>
                <!--                <span class="product-price">{{env.defaultCurrency}} {{product.price  | number:'.3'}}</span>-->
            </div>
        </div>
        <div class="col-md-6 col-12">
            <div class="">
                <label i18n="@@availability">Availability</label><br>
                <span class="badge badge-success" *ngIf="product.inStock()" i18n>In Stock</span><span
                    class="badge badge-danger" *ngIf="!product.inStock()" i18n>Out of Stock</span>
            </div>
        </div>


    </div>


    <div class="pt-3">

        <div *ngIf="product.inStock()">
            <div i18n>Quantity</div>
            <div class="component-cont">

                <input [min]="1"
                       style="   width: 58px;border: 1px solid #f0f0f0;border-radius: 5px; outline: none !important;"
                       type="number" [ngModel]="qty" (ngModelChange)="newValue($event)"/>
            </div>

        </div>
    </div>

    <div>
        <app-product-options *ngIf="configurableProductOptions.length > 0"
                             [productOptions]="configurableProductOptions"></app-product-options>
    </div>

<!--    <div class="buttons">-->
<!--        <div class="addToCartButton">-->
<!--            <button [disabled]="isAdding || !product.inStock()" class="btn btn-primary btn-block"-->
<!--                    style="padding: 8px 50px; margin-top: 20px " (click)="addItemToCart()">-->

<!--                <table width="100%">-->
<!--                    <tr>-->
<!--                        <td><img *ngIf="isAdding" src="assets/loader.gif" width="15" style="width: 15px;"/></td>-->
<!--                        <td><span *ngIf="!isAdding && product.inStock()" i18n>    ADD TO CART</span>-->
<!--                            <span *ngIf="isAdding && product.inStock()" i18n>   ADDING PRODUCT...</span>-->
<!--                            <span *ngIf="!product.inStock()" i18n>   Out of stock</span>-->
<!--                        </td>-->
<!--                    </tr>-->

<!--                </table>-->
<!--            </button>-->
<!--        </div>-->

<!--    </div>-->
<!--    <div class="row pt-3">-->
<!--        <div class="col-md-5"><a href="#" (click)="addItemToWishlist($event)" i18n><i class="la la-heart"></i> Add to-->
<!--            wishlist</a></div>-->
<!--        &lt;!&ndash;        <div class="col-md-3"><i class="fa fa-bar-chart" i18n></i> Compare</div>&ndash;&gt;-->
<!--    </div>-->
    <br>
    <br>
    <br>


</div>

